import Pluralize from 'pluralize';
import { getMonthName } from '@shared/utils/converters';

export const capitalize = string => {
  if (!string) return string;

  const lower = string.toLowerCase();

  return `${string[0].toUpperCase()}${lower.slice(1)}`;
};

export const camelCaseToTitleCase = camelCase => {
  if (camelCase === null || camelCase.includes(' ')) {
    return camelCase;
  }

  // Capitalize the first letter of each word
  const spaceSeparated = camelCase.replace(/([A-Z])/g, ' $1').toLowerCase();

  return spaceSeparated
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

// parts is an array of arrays where the first item of
// each array is the term used and the second is the count.
// Example:
//   [['year', 10], ['month', 5]]
export const joinParts = (parts, delimiter = ', ') =>
  parts
    .filter(([_term, count]) => !!count) // eslint-disable-line no-unused-vars
    .map(([term, count]) => `${count} ${Pluralize(term, count)}`)
    .join(delimiter);

// prepend the correct article(a/an to the word passed in)
export const prependArticleToNoun = (noun, capitalizeFirstLetter = false) => {
  if (!noun) return '';
  let result = '';
  if (['a', 'e', 'i', 'o', 'u'].includes(noun[0].toLowerCase())) {
    result = `an ${noun}`;
  } else {
    result = `a ${noun}`;
  }
  return capitalizeFirstLetter
    ? `${result[0].toUpperCase()}${result.slice(1)}`
    : result;
};

export const formatMonthName = date => {
  if (!date || Number.isNaN(date.getTime())) {
    return null;
  }
  const monthIndex = date.getMonth();
  const shortMonth = getMonthName(monthIndex);
  if (!shortMonth) {
    return null;
  }
  return shortMonth.charAt(0) + shortMonth.slice(1).toLowerCase() + '.';
};

// Read straight from the string: building a Date would shift a UTC-midnight
// settlement into the previous month in US timezones.
export const settlementMonthKey = settlementAt => {
  const match = /^(\d{4}-\d{2})/.exec(settlementAt ?? '');
  return match ? match[1] : null;
};
